/* store/index.js 状态管理 */
import { Vue } from "@plugins";

import Vuex from "vuex";

Vue.use(Vuex);

// 导入Tabs标签列表
import tabs from "./modules/tabs/index.js";
// 导入管理员信息
import admin from "./modules/admin/index.js";
// 导入主题
import theme from "./modules/theme/index.js";

export default new Vuex.Store({
  state: {
    // 路由列表
    routerList: [],
    // 菜单列表
    menuList: [],
    // 面包屑列表
    breadList: [],
    // 权限列表
    permissionList: [],
    // 是否初始化
    isInit: false,
  },

  getters: {},

  mutations: {
    /**
     * 设置路由列表
     * @param {*} state
     * @param {*} routerList
     */
    setRouterList(state, routerList) {
      state.routerList = routerList;
    },
    /**
     * 设置菜单列表
     * @param {*} state
     * @param {*} menuList
     */
    setMenuList(state, menuList) {
      state.menuList = menuList;
    },
    /**
     * 设置面包屑列表
     * @param {*} state
     * @param {*} breadList
     */
    setBreadList(state, breadList) {
      state.breadList = breadList;
    },
    /**
     * 设置权限列表
     * @param {*} state
     * @param {*} permissionList
     */
    setPermissionList(state, permissionList) {
      state.permissionList = permissionList;
    },
    /**
     * 设置是否初始化
     * @param {*} state
     * @param {*} isInit
     */
    setIsInit(state, isInit) {
      state.isInit = isInit;
    },
    /**
     * 清除状态
     */
    clear(state) {
      state.routerList = [];
      state.menuList = [];
      state.breadList = [];
      state.permissionList = [];
      state.isInit = false;
      state.admin.adminInfo = [];
      state.tabs.tabsList = [];
      sessionStorage.removeItem("jr_adminStore");
    },
  },

  actions: {},

  modules: {
    // 标签列表
    tabs,
    admin,
    theme,
  },
});
